"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4588],{

/***/ 28295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89289);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25934);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61953);
/* harmony import */ var _mui_icons_material_ArrowBackIos__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20724);
/* harmony import */ var _mui_icons_material_ArrowForwardIos__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(13379);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30719);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77366);
/* harmony import */ var _Banner_StyledSwiper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98121);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(13929);
/* harmony import */ var utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24994);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(39086);
/* harmony import */ var store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86377);
/* harmony import */ var utils_hooks_useBannerGA__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(778);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  object-fit: cover;\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


















const modules = [
    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Lazy */ .oM
];
const Img = _emotion_styled__WEBPACK_IMPORTED_MODULE_8__/* ["default"].img */ .Z.img(_templateObject());
const bannerSwiperId = (0,uuid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
const Banner = (param)=>{
    let { banner , linkNamePrefix , onBannerClick , isFirst , isMobile  } = param;
    var _banner_imageDouble;
    if (isMobile) {
        var _banner_imageDouble1, _banner_imageDouble2;
        return isFirst ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
            src: banner === null || banner === void 0 ? void 0 : (_banner_imageDouble1 = banner.imageDouble) === null || _banner_imageDouble1 === void 0 ? void 0 : _banner_imageDouble1.url,
            onClick: onBannerClick,
            id: "".concat(linkNamePrefix, "-").concat(banner._id)
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
            "data-src": banner === null || banner === void 0 ? void 0 : (_banner_imageDouble2 = banner.imageDouble) === null || _banner_imageDouble2 === void 0 ? void 0 : _banner_imageDouble2.url,
            onClick: onBannerClick,
            id: "".concat(linkNamePrefix, "-").concat(banner._id),
            className: "swiper-lazy"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
        src: banner === null || banner === void 0 ? void 0 : (_banner_imageDouble = banner.imageDouble) === null || _banner_imageDouble === void 0 ? void 0 : _banner_imageDouble.url,
        onClick: onBannerClick,
        id: "".concat(linkNamePrefix, "-").concat(banner._id)
    });
};
const swiperSettings = {
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
        el: ".banner-pagination",
        clickable: true
    },
    slideToClickedSlide: true
};
const swiperAutoplay = {
    delay: 5000,
    disableOnInteraction: false
};
const BannerCarousel = (param)=>{
    let { displayInfo , classification , isMobile , linkNamePrefix , bannerLocation  } = param;
    const webview = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_10__/* .selectWebview */ .hn);
    const [swiper, setSwiper] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [hovered, setHovered] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const onNextClick = ()=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    const onPrevClick = ()=>{
        return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    const displayOpt = {
        displayAt: displayInfo,
        displayArticleClassificationIds: classification
    };
    const { data: articleBanner , isLoading: articleBannerLoading  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useBanners */ .U)(webview === null || webview === void 0 ? void 0 : webview.name, displayOpt);
    const { data: indexBanner , isLoading: indexBannerLoading  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useBanners */ .U)(webview === null || webview === void 0 ? void 0 : webview.name);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const displayBanner = displayInfo === "articlepage" ? articleBanner : !!(articleBanner === null || articleBanner === void 0 ? void 0 : articleBanner.length) ? articleBanner : indexBanner === null || indexBanner === void 0 ? void 0 : indexBanner.slice(0, 1);
    const onBannerClick = (banner)=>async ()=>{
            (0,utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_14__/* .sendBannerClick */ .y)({
                banner,
                bannerLocation
            });
            const { path , isExternalLink  } = await (0,utils_api__WEBPACK_IMPORTED_MODULE_15__/* .genPathByNavData */ .E)(banner.navData);
            if (path) {
                if (isExternalLink) {
                    window.open(path, "_blank");
                } else {
                    router.push(path);
                }
            }
        };
    (0,utils_hooks_useBannerGA__WEBPACK_IMPORTED_MODULE_11__/* .useBannerGAForCarousel */ .a)({
        bannerData: displayBanner,
        bannerLocation,
        swiper,
        isRepeated: false
    });
    (0,utils_hooks_useBannerGA__WEBPACK_IMPORTED_MODULE_11__/* .useBannerGAForCarousel */ .a)({
        bannerData: displayBanner,
        bannerLocation,
        swiper,
        isRepeated: true
    });
    if (!(displayBanner === null || displayBanner === void 0 ? void 0 : displayBanner.length)) {
        return null;
    }
    const swiperNavigation = {
        nextEl: ".instance-".concat(bannerSwiperId, " .banner-swiper-next"),
        prevEl: ".instance-".concat(bannerSwiperId, " .banner-swiper-prev")
    };
    return articleBannerLoading || indexBannerLoading || !displayBanner.length ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        sx: {
            width: "100%"
        },
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Banner_StyledSwiper__WEBPACK_IMPORTED_MODULE_9__/* .ArticlePageStyledSwiper */ ._D, {
            modules: modules,
            ...swiperSettings,
            preloadImages: !isMobile,
            lazy: isMobile,
            watchSlidesProgress: isMobile,
            loopedSlides: displayBanner === null || displayBanner === void 0 ? void 0 : displayBanner.length,
            navigation: (displayBanner === null || displayBanner === void 0 ? void 0 : displayBanner.length) > 1 ? swiperNavigation : false,
            autoplay: (displayBanner === null || displayBanner === void 0 ? void 0 : displayBanner.length) > 1 ? swiperAutoplay : false,
            onAfterInit: (swiper)=>setSwiper(swiper),
            children: [
                (displayBanner === null || displayBanner === void 0 ? void 0 : displayBanner.length) > 1 && !isMobile && hovered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    className: "instance-".concat(bannerSwiperId),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "banner-swiper-next",
                            onClick: onNextClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ArrowForwardIos__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                fontSize: "small"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "banner-swiper-prev",
                            onClick: onPrevClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ArrowBackIos__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "banner-pagination"
                }),
                displayBanner === null || displayBanner === void 0 ? void 0 : displayBanner.map((banner, index)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Banner, {
                            banner: banner,
                            onBannerClick: onBannerClick(banner),
                            isMobile: isMobile,
                            linkNamePrefix: linkNamePrefix,
                            isFirst: index === 0
                        })
                    }, banner === null || banner === void 0 ? void 0 : banner._id);
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BannerCarousel);


/***/ }),

/***/ 47216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    margin: 0;\n  }\n\n  .ql-align-center {\n    text-align: center;\n  }\n  .ql-align-right {\n    text-align: right;\n  }\n  .ql-align-justify {\n    text-align: justify;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    font-size: 18px;\n    letter-spacing: 0.02rem;\n    line-height: 2rem;\n  }\n\n  img {\n    margin: 18px 0;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .Z.span(_templateObject());
const ArticleContent = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Content)(_templateObject1());
const HTMLContent = (param)=>{
    let { content , type  } = param;
    if (!content) {
        return null;
    }
    return type === "article" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArticleContent, {
        dangerouslySetInnerHTML: {
            __html: content
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, {
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HTMLContent);


/***/ }),

/***/ 54996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98700);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const ResponsiveDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), _mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveDiv);


/***/ }),

/***/ 28086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61953);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13946);
/* harmony import */ var components_common_ResponsiveDiv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54996);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98780);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  height: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const Scrollable = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const ScrollableResponsiveDiv = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(components_common_ResponsiveDiv__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject1());
const ScrollableWrapper = (param)=>{
    let { children , responsive =false , onCopy =null , containerId =null , wrapperRef , isAutoScroll =false  } = param;
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useShowScrollToTopButton */ .zi)();
    return responsive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ScrollableResponsiveDiv, {
        onCopy: onCopy,
        ref: wrapperRef,
        onScroll: showScrollButton,
        id: containerId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                showButton: showButton,
                scrollableRef: wrapperRef,
                isAutoScroll: isAutoScroll
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Scrollable, {
        onCopy: onCopy,
        ref: wrapperRef,
        onScroll: showScrollButton,
        id: containerId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                showButton: showButton,
                scrollableRef: wrapperRef,
                isAutoScroll: isAutoScroll
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollableWrapper);


/***/ }),

/***/ 42807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89289);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62097);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29630);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79072);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77366);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33863);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73221);
/* harmony import */ var store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86377);
/* harmony import */ var _utils_native_notifier__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11634);
/* harmony import */ var utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30905);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47624);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52915);
/* harmony import */ var components_common_Hidden__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18450);
/* harmony import */ var store_toast_toastSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47092);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


















const HoverAbsolute = _emotion_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme , isColumn  } = param;
    return "\n    color: ".concat(theme.palette.text.secondary, ";\n    position: absolute;\n    top: ").concat(isColumn ? 0 : "-4px", ";\n    left: ").concat(isColumn ? "54px" : "50%", ";\n    transform: ").concat(isColumn ? "translate(0%, 13%)" : "translate(-50%, -100%)", ";\n    background-color: rgba(256, 256, 256, 0.9);\n    width: auto;\n    white-space: nowrap;\n    border-radius: 6px;\n    padding: 6px;\n    z-index: 4;\n  ");
});
const genLink = (route, URL_UTM)=>{
    return config_constants__WEBPACK_IMPORTED_MODULE_6__/* .LS_APP_DOMAIN */ ._8 + route + URL_UTM;
};
const genShortLink = async (route, URL_UTM)=>{
    const link = genLink(route, URL_UTM);
    const [shortLinks, error] = await (0,utils_api__WEBPACK_IMPORTED_MODULE_11__/* .generateShortUrls */ .d)({
        urls: [
            link
        ]
    });
    return [
        shortLinks[link],
        error
    ];
};
const ShareIcon = (param)=>{
    let { iconComponent , onClick , isColumn , toastContent  } = param;
    const [isHover, setIsHover] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        onClick: onClick,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        sx: {
            position: "relative",
            cursor: "pointer"
        },
        backgroundColor: isHover ? "primary.bgPlus1" : "grey.third",
        px: 4,
        py: 2.5,
        borderRadius: "30px",
        children: [
            isHover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HoverAbsolute, {
                isColumn: isColumn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    children: toastContent
                })
            }),
            iconComponent(isHover)
        ]
    });
};
const ShareButton = (param)=>{
    let { shareText , isColumn , isCenter , utmSource  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const webview = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectWebview */ .hn);
    const FB_UTM = "?utm_source=".concat(utmSource, "&utm_medium=share&utm_campaign=FB");
    const LINE_UTM = "?utm_source=".concat(utmSource, "&utm_medium=share&utm_campaign=LINE");
    const SHARE_UTM = "?utm_source=".concat(utmSource, "&utm_medium=share&utm_campaign=othershare");
    const COPY_UTM = "?utm_source=".concat(utmSource, "&utm_medium=share&utm_campaign=copylink");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    // 適應resize尺寸高度
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const updateWindowInnerHeight = ()=>{
            const windowInnerHeight = window.innerHeight - 100;
            setHeight(windowInnerHeight);
        };
        window.addEventListener("resize", updateWindowInnerHeight);
        updateWindowInnerHeight();
        return ()=>window.removeEventListener("resize", updateWindowInnerHeight);
    }, []);
    const onFBClick = async ()=>{
        var _router_asPath_split;
        if (!router) {
            return;
        }
        const [link, error] = await genShortLink((_router_asPath_split = router.asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[0], FB_UTM);
        if (!error) {
            window.open("https://www.facebook.com/dialog/share?app_id=".concat(config_constants__WEBPACK_IMPORTED_MODULE_6__/* .FB_APP_ID */ .f6) + "&href=".concat(encodeURIComponent(link)) + "&redirect_uri=".concat(encodeURIComponent(location.href)) + "&display=popup", "_blank");
        }
    };
    const onLineClick = async ()=>{
        var _router_asPath_split;
        if (!router) {
            return;
        }
        const [link, error] = await genShortLink((_router_asPath_split = router.asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[0], LINE_UTM);
        if (!error) {
            window.open("https://social-plugins.line.me/lineit/share?url=" + encodeURIComponent(link), "_blank");
        }
    };
    const onShareClick = async ()=>{
        var _router_asPath_split;
        const [link, error] = await genShortLink((_router_asPath_split = router.asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[0], SHARE_UTM);
        if (!error) {
            if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
                (0,_utils_native_notifier__WEBPACK_IMPORTED_MODULE_15__/* .shareUrlFromNative */ .UP)(shareText, link);
            } else {
                const shareData = {
                    title: "信義居家",
                    text: shareText,
                    url: link
                };
                try {
                    await navigator.share(shareData);
                    dispatch((0,store_toast_toastSlice__WEBPACK_IMPORTED_MODULE_10__/* .setToast */ .fz)({
                        open: true,
                        message: "分享成功"
                    }));
                } catch (err) {
                    console.log(err);
                }
            }
        }
    };
    const onCloneLinkClick = async ()=>{
        var _router_asPath_split;
        const [link, error] = await genShortLink((_router_asPath_split = router.asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[0], COPY_UTM);
        if (!error) {
            if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
                (0,_utils_native_notifier__WEBPACK_IMPORTED_MODULE_15__/* .copyTextFromNative */ .y6)(link);
                dispatch((0,store_toast_toastSlice__WEBPACK_IMPORTED_MODULE_10__/* .setToast */ .fz)({
                    open: true,
                    message: "複製完成"
                }));
            } else {
                (0,utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .copyToClipboard */ .vQ)(link);
                dispatch((0,store_toast_toastSlice__WEBPACK_IMPORTED_MODULE_10__/* .setToast */ .fz)({
                    open: true,
                    message: "複製完成"
                }));
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        sx: {
            height: isColumn && height
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
            direction: isColumn ? "column" : "row",
            sx: {
                height: isColumn && height
            },
            justifyContent: {
                lg: isCenter ? "center" : "",
                xl: "center"
            },
            alignItems: "center",
            container: true,
            columnSpacing: isColumn ? 0 : 3,
            rowSpacing: isColumn ? 3 : 0,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShareIcon, {
                        isColumn: isColumn,
                        toastContent: "更多分享",
                        iconComponent: (isHover)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                                container: true,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        width: 20,
                                        height: 20,
                                        alt: "",
                                        src: "/img/share.svg",
                                        style: {
                                            display: "block"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Hidden__WEBPACK_IMPORTED_MODULE_9__/* .HideInDesktopBox */ .aI, {
                                        ml: 1.5,
                                        children: "分享"
                                    })
                                ]
                            }),
                        onClick: onShareClick
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Hidden__WEBPACK_IMPORTED_MODULE_9__/* .HideInMobileGrid */ .W, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShareIcon, {
                        isColumn: isColumn,
                        toastContent: "複製網址",
                        iconComponent: (isHover)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                width: 20,
                                height: 20,
                                alt: "",
                                src: "/img/copy.svg",
                                style: {
                                    display: "block"
                                }
                            }),
                        onClick: onCloneLinkClick
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Hidden__WEBPACK_IMPORTED_MODULE_9__/* .HideInMobileGrid */ .W, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShareIcon, {
                        isColumn: isColumn,
                        toastContent: "分享至FB",
                        iconComponent: (isHover)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_17__/* .FacebookIconSVG */ .x, {
                                theme: theme,
                                $ptr: true,
                                $color: "blue.main",
                                width: "20px",
                                height: "20px",
                                display: "block"
                            }),
                        onClick: onFBClick
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Hidden__WEBPACK_IMPORTED_MODULE_9__/* .HideInMobileGrid */ .W, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShareIcon, {
                        isColumn: isColumn,
                        toastContent: "分享至LINE",
                        iconComponent: (isHover)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_18__/* .LineCircleSVG */ .L, {
                                theme: theme,
                                $ptr: true,
                                width: "20px",
                                height: "20px",
                                display: "block"
                            }),
                        onClick: onLineClick
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShareButton);


/***/ }),

/***/ 11449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39705);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23855);




const MetaTags = (param)=>{
    let { resolvedUrl , article  } = param;
    var _article_keywords, _article_image, _article_vender, _article_vender1, _article_vender_introductionInfo, _article_vender2, _article_image1;
    const pathName = resolvedUrl === null || resolvedUrl === void 0 ? void 0 : resolvedUrl.split("?")[0];
    const title = "".concat((article === null || article === void 0 ? void 0 : article.title) || "", " - 信義居家");
    const keywords = article === null || article === void 0 ? void 0 : (_article_keywords = article.keywords) === null || _article_keywords === void 0 ? void 0 : _article_keywords.map((keyword)=>keyword.name).join(",");
    const classification = article === null || article === void 0 ? void 0 : article.articleClassification;
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "首頁",
                item: "https://livinglife.com.tw"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "找好文",
                item: "https://livinglife.com.tw/article"
            },
            {
                "@type": "ListItem",
                position: 3,
                name: classification === null || classification === void 0 ? void 0 : classification.name,
                item: "https://livinglife.com.tw/article-classification/".concat(classification === null || classification === void 0 ? void 0 : classification.urlId)
            },
            {
                "@type": "ListItem",
                position: 4,
                name: article === null || article === void 0 ? void 0 : article.title,
                item: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName
            }
        ]
    };
    const articleData = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article === null || article === void 0 ? void 0 : article.title,
        image: [
            article === null || article === void 0 ? void 0 : (_article_image = article.image) === null || _article_image === void 0 ? void 0 : _article_image.url
        ],
        datePublished: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(article === null || article === void 0 ? void 0 : article.createdAt), "yyyy-MM-dd"),
        dateModified: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(article === null || article === void 0 ? void 0 : article.updatedAt), "yyyy-MM-dd"),
        author: [
            {
                "@type": "Organization",
                name: ((_article_vender = article.vender) === null || _article_vender === void 0 ? void 0 : _article_vender.shortname) || (article === null || article === void 0 ? void 0 : article.byline),
                url: (article === null || article === void 0 ? void 0 : (_article_vender1 = article.vender) === null || _article_vender1 === void 0 ? void 0 : (_article_vender_introductionInfo = _article_vender1.introductionInfo) === null || _article_vender_introductionInfo === void 0 ? void 0 : _article_vender_introductionInfo.isVisible) ? "".concat(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8, "/vender/").concat((_article_vender2 = article.vender) === null || _article_vender2 === void 0 ? void 0 : _article_vender2.urlId) : undefined
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: "".concat(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName)
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: (article === null || article === void 0 ? void 0 : article.summary) || ""
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }, "keywords"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (article === null || article === void 0 ? void 0 : article.summary) || ""
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName)
            }, "og:url"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: (article === null || article === void 0 ? void 0 : (_article_image1 = article.image) === null || _article_image1 === void 0 ? void 0 : _article_image1.url) || ""
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbData)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(articleData)
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);


/***/ }),

/***/ 73250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Article_ArticleContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 27 modules
var format = __webpack_require__(39705);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(64489);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/NavigateNext.js
var NavigateNext = __webpack_require__(37958);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useArticle.js


const useArticle = function() {
    let urlId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { options , swrOptions  } = params;
    const { data , ...rest } = (0,fetchers/* useCustomSWR */.LW)(urlId && "/articles?".concat((0,lib.stringify)({
        urlId,
        isShowContent: true,
        ...options
    })), swrOptions);
    return {
        data: data === null || data === void 0 ? void 0 : data[0],
        ...rest
    };
};

// EXTERNAL MODULE: ./utils/api/hooks/useArticleClassifications.js
var useArticleClassifications = __webpack_require__(92437);
;// CONCATENATED MODULE: ./utils/api/hooks/useArticleById.js

const useArticleById = (id)=>{
    return (0,fetchers/* useCustomSWR */.LW)(id && "/articles/".concat(id));
};

// EXTERNAL MODULE: ./utils/api/hooks/useLoginData.js
var useLoginData = __webpack_require__(68056);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/general/setArticleViewed.js

const setArticleViewed = (articleId)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsPut */.OL)("/articles/".concat(articleId, "/views")));
};

// EXTERNAL MODULE: ./utils/helpers/vender-welcome-info.js
var vender_welcome_info = __webpack_require__(19575);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./utils/hooks/analytics/constants.js
var constants = __webpack_require__(42395);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./utils/hooks/analytics/GtmAgent/useGtmPageView.js


/**
 * 送出頁面瀏覽事件，同一次掛載只會送出一次
 * （避免 SWR 在切換瀏覽器分頁後重新取資料時又送一次）。
 *
 * 「只送一次」的旗標必須用 useRef，不能用 useState，理由：
 * 1. genPageViewData 由呼叫端直接傳入 inline 函式（例如 useGtmArticlePageView），
 *    每次重繪都會是新的參考，所以這個 effect 會在「每一次重繪之後」都執行。
 * 2. useState 的更新要等下一次重繪才反映。只要在旗標生效前連續重繪了兩次以上
 *    （例如伺服器端算不出、必須等瀏覽器接手後才修正的值，會在畫面呈現前多繪一次），
 *    那幾次重繪各自排隊的 effect 都會讀到尚未更新的 false，事件就會重複送出。
 * 3. useRef 的寫入是同步生效的，先執行的 effect 標記完，後面排隊的 effect 立刻讀得到，
 *    才能真正保證只送一次。
 */ const useGtmPageView = (genPageViewData)=>{
    const isSentRef = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        if (isSentRef.current || !genPageViewData) {
            return;
        }
        try {
            const data = genPageViewData();
            if (data !== null) {
                isSentRef.current = true;
                GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM(data);
            }
        } catch (err) {}
    }, [
        genPageViewData
    ]);
};

;// CONCATENATED MODULE: ./utils/hooks/analytics/GtmAgent/useGtmArticlePageView.js



const useGtmArticlePageView = (article)=>{
    useGtmPageView(()=>({
            event: constants/* ARTICLE_PAGEVIEW */.a4,
            living_article_id: article._id,
            living_article_catlog: article.articleClassification.name,
            living_article_tags: article.keywords.filter((keyword)=>keyword.isVisible).map((keyword)=>keyword.name),
            living_article_date: (0,format/* default */.Z)((0,parseISO/* default */.Z)(article.publishStartTime), "yyyy/MM/dd")
        }));
};

// EXTERNAL MODULE: ./utils/hooks/index.js
var hooks = __webpack_require__(13946);
// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/SVGElements/Eye.js
var Eye = __webpack_require__(23183);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/Clock.js


const ClockSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            className: "clock",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1 5a1 1 0 10-2 0v6a1 1 0 00.553.894l4 2a1 1 0 10.894-1.788L13 11.382V6z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/SVGElements/Pen.js
var Pen = __webpack_require__(79193);
// EXTERNAL MODULE: ./components/common/TagButton/index.js
var TagButton = __webpack_require__(25133);
// EXTERNAL MODULE: ./components/common/HTMLContent/index.js
var HTMLContent = __webpack_require__(47216);
// EXTERNAL MODULE: ./components/common/VenderLink/index.js
var VenderLink = __webpack_require__(90879);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
;// CONCATENATED MODULE: ./utils/api/general/recordArticleReserveClicked.js

const recordArticleReserveClicked = (articleId)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsPut */.OL)("/articles/".concat(articleId, "/gotoReservationViews")));
};

// EXTERNAL MODULE: ./utils/api/general/genPathByNavData.js
var genPathByNavData = __webpack_require__(39086);
// EXTERNAL MODULE: ./store/cache/cacheSlice.js
var cacheSlice = __webpack_require__(24363);
;// CONCATENATED MODULE: ./components/pages/Article/ArticleContent/Controls.js







const Controls = (param)=>{
    let { article  } = param;
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const onReserveClick = async ()=>{
        var _article_navData;
        dispatch((0,cacheSlice/* setNavigateInfo */.nb)({
            id: article._id,
            type: "Article"
        }));
        recordArticleReserveClicked(article._id);
        if (!!(article === null || article === void 0 ? void 0 : (_article_navData = article.navData) === null || _article_navData === void 0 ? void 0 : _article_navData.page)) {
            const { path , isExternalLink  } = await (0,genPathByNavData/* genPathByNavData */.E)(article.navData);
            if (path) {
                if (isExternalLink) {
                    window.open(path, "_blank");
                } else {
                    if (/^\/service\//.test(path)) {
                        var _article_vender;
                        dispatch((0,cacheSlice/* setPreselectVender */.bE)(((_article_vender = article.vender) === null || _article_vender === void 0 ? void 0 : _article_vender._id) || null));
                    }
                    router.push(path);
                }
            }
        } else {
            router.push("/");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 4,
        display: "flex",
        children: (article === null || article === void 0 ? void 0 : article.isDisplayGotoReservation) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            id: "book",
            className: "action living_track_article_gobook",
            variant: "contained",
            color: "primary",
            onClick: onReserveClick,
            sx: {
                whiteSpace: "nowrap",
                position: "static",
                marginRight: 2
            },
            children: (article === null || article === void 0 ? void 0 : article.gotoReservationDefaultName) || "前往預約"
        })
    });
};
/* harmony default export */ var ArticleContent_Controls = (Controls);

// EXTERNAL MODULE: ./components/common/ShareButton/index.js
var ShareButton = __webpack_require__(42807);
// EXTERNAL MODULE: ./utils/api/hooks/useAlbums.js
var useAlbums = __webpack_require__(55108);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
;// CONCATENATED MODULE: ./components/pages/Article/ArticleContent/VenderInfo.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 80%;\n  margin: 0 8px;\n  border-radius: 5px;\n  overflow: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100px;\n  width: 100px;\n  object-fit: cover;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}














const DynamicAlbumContent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2334), __webpack_require__.e(9689)]).then(__webpack_require__.bind(__webpack_require__, 22334)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22334)
            ]
    }
});
const ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
const Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
const Img = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject2());
const VenderLogoImg = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject3());
const VenderIntro = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject4());
const AlbumLink = (param)=>{
    let { venderAlbum , onAlbumClick  } = param;
    var _venderAlbum_frontCover, _venderAlbum_frontCover_image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 4,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Absolute, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                    href: "",
                    onClick: (e)=>onAlbumClick(e, venderAlbum),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                        src: venderAlbum === null || venderAlbum === void 0 ? void 0 : (_venderAlbum_frontCover = venderAlbum.frontCover) === null || _venderAlbum_frontCover === void 0 ? void 0 : (_venderAlbum_frontCover_image = _venderAlbum_frontCover.image) === null || _venderAlbum_frontCover_image === void 0 ? void 0 : _venderAlbum_frontCover_image.url
                    })
                })
            })
        })
    });
};
const VenderInfo = (param)=>{
    let { venderData , articleByLine  } = param;
    var _venderAlbums_slice, _venderData_introductionInfo, _venderData_introductionInfo1, _venderData_introductionInfo2;
    const { data: venderAlbums , isLoading: isAlbumLoading  } = (0,useAlbums/* useAlbums */.L)({
        venderId: venderData === null || venderData === void 0 ? void 0 : venderData._id,
        limit: 3
    });
    const { logoImage , brieflyDescribeText  } = (0,vender_welcome_info/* getVenderWelcomeInfo */.u)(venderData);
    const displayVenderAlbums = (venderAlbums === null || venderAlbums === void 0 ? void 0 : (_venderAlbums_slice = venderAlbums.slice) === null || _venderAlbums_slice === void 0 ? void 0 : _venderAlbums_slice.call(venderAlbums, 0, 3)) || [];
    const router = (0,next_router.useRouter)();
    // album content modal
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const { albumModal , closeAlbumModal , onAlbumClick , onAlbumContentClose  } = (0,hooks/* useAlbumModal */.Xh)("/article", router, {
        webview,
        nativeHeaderHandler: ()=>null
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        mb: 14,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                mb: 6,
                fontWeight: "fontWeightBold",
                children: "文章作者"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        display: "flex",
                        justifyContent: "center",
                        xs: 12,
                        mb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "flex",
                            justifyContent: "center",
                            sx: {
                                borderRadius: "50%",
                                overflow: "hidden"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderLogoImg, {
                                alt: "",
                                src: (logoImage === null || logoImage === void 0 ? void 0 : logoImage.url) || "/img/img_headshot_default.png",
                                onClick: (venderData === null || venderData === void 0 ? void 0 : (_venderData_introductionInfo = venderData.introductionInfo) === null || _venderData_introductionInfo === void 0 ? void 0 : _venderData_introductionInfo.isVisible) ? ()=>{
                                    router.push("/vender/".concat(venderData === null || venderData === void 0 ? void 0 : venderData.urlId));
                                } : null,
                                style: {
                                    cursor: (venderData === null || venderData === void 0 ? void 0 : (_venderData_introductionInfo1 = venderData.introductionInfo) === null || _venderData_introductionInfo1 === void 0 ? void 0 : _venderData_introductionInfo1.isVisible) ? "pointer" : "default"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        display: "flex",
                        justifyContent: "center",
                        xs: 12,
                        mb: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "24px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                fontWeight: "fontWeightBold",
                                children: (venderData === null || venderData === void 0 ? void 0 : (_venderData_introductionInfo2 = venderData.introductionInfo) === null || _venderData_introductionInfo2 === void 0 ? void 0 : _venderData_introductionInfo2.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                    href: "/vender/".concat(venderData === null || venderData === void 0 ? void 0 : venderData.urlId),
                                    $origin: true,
                                    children: venderData === null || venderData === void 0 ? void 0 : venderData.shortname
                                }) : articleByLine
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        display: "flex",
                        justifyContent: "center",
                        xs: 12,
                        mb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderIntro, {
                            variant: "caption",
                            color: "textSecondary",
                            children: brieflyDescribeText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                display: "flex",
                justifyContent: "start",
                xs: 12,
                children: venderData && !!displayVenderAlbums.length && (displayVenderAlbums === null || displayVenderAlbums === void 0 ? void 0 : displayVenderAlbums.map((venderAlbum)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlbumLink, {
                        venderAlbum: venderAlbum,
                        onAlbumClick: onAlbumClick
                    });
                }))
            }),
            (router === null || router === void 0 ? void 0 : router.isReady) && albumModal.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FullscreenModal */.OW, {
                open: albumModal.open,
                onClose: closeAlbumModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAlbumContent, {
                    onClose: onAlbumContentClose,
                    closeModal: closeAlbumModal,
                    fallbackData: albumModal.fallbackData
                })
            })
        ]
    });
};
/* harmony default export */ var ArticleContent_VenderInfo = (VenderInfo);

// EXTERNAL MODULE: ./components/common/GuessLikesList/index.js + 2 modules
var GuessLikesList = __webpack_require__(26710);
// EXTERNAL MODULE: ./components/common/BannerCarouselForArticle/index.js
var BannerCarouselForArticle = __webpack_require__(28295);
// EXTERNAL MODULE: ./utils/api/hooks/useArticles.js
var useArticles = __webpack_require__(56168);
// EXTERNAL MODULE: ./components/common/CursorPointerBox.js/index.js
var CursorPointerBox_js = __webpack_require__(69443);
;// CONCATENATED MODULE: ./components/pages/Article/ArticleContent/LatestArticle.js

function LatestArticle_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 70%;\n  margin: 0 8px;\n  border-radius: 12px;\n  overflow: hidden;\n"
    ]);
    LatestArticle_templateObject = function() {
        return data;
    };
    return data;
}
function LatestArticle_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    LatestArticle_templateObject1 = function() {
        return data;
    };
    return data;
}
function LatestArticle_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    LatestArticle_templateObject2 = function() {
        return data;
    };
    return data;
}








const LatestArticle_ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(LatestArticle_templateObject());
const LatestArticle_Absolute = emotion_styled_browser_esm/* default.div */.Z.div(LatestArticle_templateObject1());
const LatestArticle_Img = emotion_styled_browser_esm/* default.img */.Z.img(LatestArticle_templateObject2());
const LatestArticle = ()=>{
    const { data: articles , isLoading: isArticleLoading  } = (0,useArticles/* useArticles */.l)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isArticleLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    mb: 6,
                    fontWeight: "fontWeightBold",
                    children: "最新上架"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: articles && (articles === null || articles === void 0 ? void 0 : articles.slice(0, 3).map((item)=>{
                        var _item_image;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                href: "/article/".concat(item === null || item === void 0 ? void 0 : item.urlId),
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CursorPointerBox_js/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle_ImgRect, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle_Absolute, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle_Img, {
                                                    alt: "",
                                                    src: ((_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url) || "/img/img_headshot_default.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "text.minus2",
                                            mt: 3,
                                            mx: 2,
                                            children: item === null || item === void 0 ? void 0 : item.title
                                        })
                                    ]
                                })
                            })
                        }, item._id);
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var ArticleContent_LatestArticle = (LatestArticle);

;// CONCATENATED MODULE: ./components/common/SVGElements/ArticleMainImgLogo.js


const ArticleMainImgLogo = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "106",
        height: "15",
        fill: "none",
        viewBox: "0 0 106 15",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M66.91 6.685V8c-.739.043-1.671.07-2.797.08v.606h3.807a12.568 12.568 0 0 1-.38-2.06h1.589c.055.696.177 1.385.363 2.06h3.824v1.41H70.04c.251.467.563.903.927 1.298a69.46 69.46 0 0 0 2.253-1.01V12c-.332.161-.652.307-.961.438.337.2.695.369 1.068.502v1.705a8.899 8.899 0 0 1-2.697-1.543 21.243 21.243 0 0 1-5.398 1.282v-1.516c1.191-.045 2.615-.353 4.27-.925a9.13 9.13 0 0 1-1.102-1.847h-4.27v.698c.87-.032 1.742-.07 2.613-.113v1.414c-.815.043-1.698.08-2.647.113a2.896 2.896 0 0 1-.481 1.395c-.474.509-.987.768-1.54.78h-2.349v-1.386h1.871c.63 0 .945-.244.944-.73-.97.021-2.003.043-3.094.064v-1.444c1.015 0 2.046-.016 3.094-.048v-.743h-3.246v-1.4h3.229v-.605c-.884.009-1.834.014-2.849.016V6.798c2.903 0 5.315-.037 7.235-.113ZM61.91 0h1.738c.043.293.092.58.15.86h5.214c.066-.28.133-.557.199-.828h1.682a8.69 8.69 0 0 1-.166.828h2.562v1.38h-6.098v.631H73.1v1.33h-5.908v.645h6.124V6.24H59.327V4.846h6.23v-.644h-5.93v-1.33h5.93v-.633H59.46V.86h2.598a23.507 23.507 0 0 1-.147-.86Zm8.392 6.701h1.708c.142.517.313 1.026.513 1.525h-1.77a12.376 12.376 0 0 1-.451-1.525ZM75.949.535 87.53.551a2.106 2.106 0 0 1 1.407.66c.32.314.48.812.48 1.493 0 .68-.16 1.179-.48 1.492a1.805 1.805 0 0 1-.644.436 1.896 1.896 0 0 1-.78.133h-9.9c-.07 3.77-.266 7.063-.585 9.882l-1.663-.018c.33-2.855.525-6.557.583-11.106V.535Zm1.683 2.827h9.35c.457-.053.688-.259.688-.606 0-.509-.19-.79-.568-.844h-9.453l-.017 1.45Zm.548 3.029h4.673V5.25h1.697v1.118h4.839v1.46h-4.843v1.51h1.683c.936.075 1.662.334 2.178.778.267.19.481.439.625.724.143.286.212.6.199.915 0 .808-.246 1.414-.739 1.818a3.305 3.305 0 0 1-2.16.807h-7.517V9.332h4.038V7.836H78.18V6.391Zm2.23 6.531 5.407-.016c1.097-.021 1.674-.4 1.731-1.136-.057-.596-.531-.935-1.424-1.022H80.41v2.174ZM42.565 5.916c.971-1.161 1.768-3.008 2.383-5.559h1.733a23.927 23.927 0 0 1-1.1 3.31v10.97h-1.629V6.74a9.356 9.356 0 0 1-1.387 1.538V5.916Zm11.975 4.258h-7.395v4.364h7.343a2.528 2.528 0 0 0 1.666-.632 2.19 2.19 0 0 0 .64-1.591 1.969 1.969 0 0 0-.122-.808 2.054 2.054 0 0 0-.443-.7 2.368 2.368 0 0 0-.778-.477c-.29-.109-.6-.162-.911-.156Zm-.257 3.05h-5.492v-1.77h5.424c.652.11.978.396.978.86 0 .54-.303.843-.91.91ZM47.574.827h8.614v1.395h-8.614V.828Zm8.87 7.075h-9.282v1.395h9.282V7.903Zm-9.848-4.739h10.57v1.428h-10.57V3.164Zm9.848 2.4H47.18V6.96h9.265V5.565Zm49.257 1.802a12.807 12.807 0 0 0-4.576 1.445A25.698 25.698 0 0 0 106 12.286v1.818a27.578 27.578 0 0 1-5.338-3.764 9.897 9.897 0 0 1-.498 2.936c-.376.867-1.125 1.327-2.246 1.38a11.54 11.54 0 0 1-2.437-.201V13.01c.684.123 1.38.182 2.076.178.612 0 .99-.222 1.132-.665.217-.434.343-1.108.378-2.029-1.706 1.46-4.155 2.57-7.348 3.326v-1.63c3.36-.706 5.757-1.918 7.194-3.634a4.81 4.81 0 0 0-.242-.683c-1.402 1.454-3.72 2.514-6.952 3.18V9.477A11.859 11.859 0 0 0 97.676 6.9a2.943 2.943 0 0 0-.685-.145c-1.371.68-3.137 1.228-5.272 1.643v-1.59c2.154-.23 3.871-.768 5.152-1.615h-2.797V3.7h9.214v1.494H99.18a6.714 6.714 0 0 1-.669.584c.412.18.78.439 1.081.76.302.321.53.697.67 1.105a11.8 11.8 0 0 1 5.439-1.72v1.444Zm-12.28-2.24V2.759h9.822c.607 0 .91.202.91.606 0 .293-.126.916-.378 1.868h1.708c.194-.486.308-1.227.342-2.222-.011-.962-.723-1.52-2.135-1.671l-4.246-.025V.202h-1.768v1.112H91.74l.017 3.813h1.663ZM0 11.479l7.826-1.91 8.437-6.286 4.619 3.157 4.05-1.029-6.839-4.91a2.708 2.708 0 0 0-3.151.009C11.677 2.894 4.039 8.475 0 11.478ZM12.733 9.55l5.037-3.57-1.553-2.425-8.03 5.984 4.545.01Zm8.751-1.837-.65-1.074-4.282-2.925 1.45 2.263 3.482 1.736Zm3.4 1.696-3.658-2.5.588.969 3.07 1.53Zm8.423 2.284H.014l2.291 3.25 31.002-3.25ZM21.09 6.582l4.042-1.027 8.284 5.948H.695l7.279-1.775 17.776.038-4.66-3.185Z",
            className: "Union",
            clipRule: "evenodd",
            opacity: ".8"
        })
    });
};

// EXTERNAL MODULE: ./components/common/ScrollableWrapper/index.js
var ScrollableWrapper = __webpack_require__(28086);
;// CONCATENATED MODULE: ./components/pages/Article/ArticleContent/index.js

function ArticleContent_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ArticleContent_templateObject = function() {
        return data;
    };
    return data;
}
function ArticleContent_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  object-fit: cover;\n"
    ]);
    ArticleContent_templateObject1 = function() {
        return data;
    };
    return data;
}
function ArticleContent_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  width: 100%;\n  position: relative;\n  margin-bottom: 32px;\n  border-radius: 10px;\n  overflow: hidden;\n  -webkit-mask-image: -webkit-radial-gradient(\n    white,\n    black\n  ); // 處理 safari img & mask border-radius 於 overflow-hidden 失效問題\n"
    ]);
    ArticleContent_templateObject2 = function() {
        return data;
    };
    return data;
}
function ArticleContent_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 100%;\n  z-index: 1;\n"
    ]);
    ArticleContent_templateObject3 = function() {
        return data;
    };
    return data;
}
function ArticleContent_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 40px;\n  z-index: 2;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n"
    ]);
    ArticleContent_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n  color: rgba(256, 256, 256, 0.8);\n  margin-left: 10px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: calc((100% - 1104px) / 2);\n  height: calc(100% - 50px);\n  top: 25px;\n  left: 0;\n  z-index: 3;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 0;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1104px;\n  width: 100vw;\n  padding: 0 16px;\n  display: flex;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}






































const DynamicIdleModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9766).then(__webpack_require__.bind(__webpack_require__, 9766)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9766)
            ]
    }
});
const DynamicFooter = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6007), __webpack_require__.e(635)]).then(__webpack_require__.bind(__webpack_require__, 56007)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56007)
            ]
    },
    ssr: false
});
const CustomLink = (0,emotion_styled_browser_esm/* default */.Z)(A/* default */.Z)(ArticleContent_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    transition-delay: 0s;\n    transition-duration: .2s;\n    transition-property: color;\n    transition-timing-function: ease;\n\n    &:hover {\n      color: ".concat(theme.palette.primary.main, ";\n    }\n  ");
});
const ArticleContent_Img = emotion_styled_browser_esm/* default.img */.Z.img(ArticleContent_templateObject1());
const MainImgBox = emotion_styled_browser_esm/* default.div */.Z.div(ArticleContent_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n  padding-bottom: 50%;\n  ".concat(theme.breakpoints.up("lg"), " {\n    padding-bottom: 37.5%;\n  }\n  ");
});
const MainImg = (0,emotion_styled_browser_esm/* default */.Z)(ArticleContent_Img)(ArticleContent_templateObject3());
const MainImgMask = emotion_styled_browser_esm/* default.div */.Z.div(ArticleContent_templateObject4());
const VenderName = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject5());
const Scrollable = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
const ArticleContent_Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());
const Sticky = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8());
const ArticleWrapper = (0,emotion_styled_browser_esm/* default */.Z)(ContentWrapper/* default */.Z)(_templateObject9());
const ArticleContentWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject10());
const SmallVenderIconImage = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject11());
const Line = emotion_styled_browser_esm/* default.span */.Z.span(_templateObject12(), (param)=>{
    let { theme  } = param;
    return "\n    display: inline-block;\n    width: 100%;\n    height: 1px;\n    background-color: ".concat(theme.palette.background.line, ";\n    margin-top: 48px;\n  ");
});
const BottomSpacing = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject13(), (param)=>{
    let { theme  } = param;
    return "\n    margin-bottom: 98px;\n    ".concat(theme.breakpoints.up("lg"), " {\n      margin-bottom: 198px;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      margin-bottom: 222px;\n    }\n  ");
});
const MainImageMaskWithLogo = (param)=>{
    let { venderName , venderVatNo  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: venderVatNo && venderVatNo !== "22354940" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainImgMask, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleMainImgLogo, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderName, {
                    children: "。" + venderName
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImgMask, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleMainImgLogo, {})
        })
    });
};
const IconInfos = (param)=>{
    let { article  } = param;
    var _article_vender, _article_vender_introductionInfo;
    const theme = (0,useTheme/* default */.Z)();
    const isMedium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var _article_publicViews;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mr: 4,
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye/* EyeSVG */.P, {
                        width: isMedium ? "16px" : "20px",
                        height: isMedium ? "16px" : "20px",
                        $color: "text.disabled"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        ml: 1.5,
                        color: "text.disabled",
                        sx: {
                            typography: {
                                xs: "bodyXs",
                                md: "bodySmall"
                            }
                        },
                        children: (_article_publicViews = article === null || article === void 0 ? void 0 : article.publicViews) !== null && _article_publicViews !== void 0 ? _article_publicViews : 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mr: 4,
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockSVG, {
                        width: isMedium ? "16px" : "20px",
                        height: isMedium ? "16px" : "20px",
                        $color: "text.disabled"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        ml: 1.5,
                        color: "text.disabled",
                        sx: {
                            typography: {
                                xs: "bodyXs",
                                md: "bodySmall"
                            }
                        },
                        children: !!(article === null || article === void 0 ? void 0 : article.displayPublishDate) && (0,format/* default */.Z)((0,parseISO/* default */.Z)(article.displayPublishDate), "yyyy/MM/dd")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                children: (article === null || article === void 0 ? void 0 : (_article_vender = article.vender) === null || _article_vender === void 0 ? void 0 : (_article_vender_introductionInfo = _article_vender.introductionInfo) === null || _article_vender_introductionInfo === void 0 ? void 0 : _article_vender_introductionInfo.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderLink/* default */.Z, {
                    vender: article === null || article === void 0 ? void 0 : article.vender,
                    width: isMedium ? "16px" : "20px",
                    height: isMedium ? "16px" : "20px"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pen/* PenSVG */.m, {
                            width: isMedium ? "16px" : "20px",
                            height: isMedium ? "16px" : "20px",
                            $color: "text.disabled"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            ml: 1.5,
                            color: "text.disabled",
                            sx: {
                                typography: {
                                    xs: "bodyXs",
                                    md: "bodySmall"
                                }
                            },
                            children: article === null || article === void 0 ? void 0 : article.byline
                        })
                    ]
                })
            })
        ]
    });
};
const ArticleClassifications = (param)=>{
    let { articleClassificationItem  } = param;
    var _articleClassificationItem_articles;
    const theme = (0,useTheme/* default */.Z)();
    const [inHover, setInHover] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
            href: "/article-classification/".concat(articleClassificationItem === null || articleClassificationItem === void 0 ? void 0 : articleClassificationItem.urlId),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                mb: 4,
                onMouseEnter: ()=>setInHover(true),
                onMouseLeave: ()=>setInHover(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: inHover ? theme.palette.primary.main : "text.minus2",
                        children: articleClassificationItem.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: inHover ? theme.palette.primary.minus2 : "textSecondary",
                        ml: 1,
                        children: "(".concat((_articleClassificationItem_articles = articleClassificationItem.articles) === null || _articleClassificationItem_articles === void 0 ? void 0 : _articleClassificationItem_articles.length, ")")
                    })
                ]
            })
        })
    });
};
const useIdleModal = (isMobile, scrollableRef)=>{
    const [idleModal, setIdleModal] = (0,react.useState)({
        open: false
    });
    const closeIdleModal = ()=>setIdleModal({
            open: false
        });
    (0,react.useEffect)(()=>{
        var _scrollableRef_current, _scrollableRef_current1;
        if (isMobile || (idleModal === null || idleModal === void 0 ? void 0 : idleModal.open)) {
            return;
        }
        let timer = null;
        const resetTimer = ()=>{
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(()=>setIdleModal({
                    open: true
                }), 60 * 1000);
        };
        resetTimer();
        document.addEventListener("mousemove", resetTimer);
        document.addEventListener("click", resetTimer);
        document.addEventListener("keypress", resetTimer);
        (_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.addEventListener("touchmove", resetTimer);
        (_scrollableRef_current1 = scrollableRef.current) === null || _scrollableRef_current1 === void 0 ? void 0 : _scrollableRef_current1.addEventListener("scroll", resetTimer);
        return ()=>{
            var _scrollableRef_current, _scrollableRef_current1;
            if (timer) {
                clearTimeout(timer);
            }
            document.removeEventListener("mousemove", resetTimer);
            document.removeEventListener("click", resetTimer);
            document.removeEventListener("keypress", resetTimer);
            (_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.removeEventListener("touchmove", resetTimer);
            (_scrollableRef_current1 = scrollableRef.current) === null || _scrollableRef_current1 === void 0 ? void 0 : _scrollableRef_current1.removeEventListener("scroll", resetTimer);
        };
    }, [
        isMobile,
        idleModal === null || idleModal === void 0 ? void 0 : idleModal.open,
        scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current
    ]);
    return {
        idleModal,
        closeIdleModal
    };
};
const ArticleContent = (param)=>{
    let { fallbackData  } = param;
    var _router_query_articleUrlId, _articleData_articleClassification, _articleData_articleClassification1, _articleData_keywords, _articleData_image, _articleData_vender, _articleById_vender, _articleData_docContents, _articleData_vender1, _articleData_vender_introductionInfo, _articleData_vender2, _articleData_vender_introductionInfo1, _articleData_vender3, _articleData_vender_introductionInfo2, _articleData_vender4, _articleData_vender5, _article_articleClassification, _article_articleClassification1;
    const theme = (0,useTheme/* default */.Z)();
    const isXLarge = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("xl"));
    const isLarge = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const isMedium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        setTimeout(()=>{
            var _scrollableRef_current;
            return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                top: 0,
                behavior: "smooth"
            }));
        }, 0);
    }, [
        router.query.articleUrlId,
        router.query.classificationUrlId
    ]);
    const { data: article , isLoading: isArticleLoading  } = useArticle((_router_query_articleUrlId = router.query.articleUrlId) === null || _router_query_articleUrlId === void 0 ? void 0 : _router_query_articleUrlId.replace(/^DOC_/, "doc_"), {
        options: (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.isForPreview) ? {
            isForPreview: true
        } : {},
        swrOptions: (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.article) && {
            fallbackData: [
                fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.article
            ]
        }
    });
    const { data: articleClassifications  } = (0,useArticleClassifications/* useArticleClassifications */.$)({
        isGetArticles: true
    });
    const showArticleClassifications = articleClassifications === null || articleClassifications === void 0 ? void 0 : articleClassifications.filter((item)=>{
        var _item_articles;
        return ((_item_articles = item.articles) === null || _item_articles === void 0 ? void 0 : _item_articles.length) > 0;
    });
    const articleData = (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.article) || article;
    const { data: articleById  } = useArticleById(articleData === null || articleData === void 0 ? void 0 : articleData._id);
    const { logoImage: articleVenderLogoImage  } = (0,vender_welcome_info/* getVenderWelcomeInfo */.u)(articleById === null || articleById === void 0 ? void 0 : articleById.vender);
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    (0,react.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            try {
                (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(false);
                (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(true);
                (0,native_notifier/* enableNativeHeaderSearch */.PP)(false);
            } catch (err) {
                console.error("native notifier error: ", err.message);
            }
        }
    }, [
        webview
    ]);
    const { isLoading: isAuthLoading  } = (0,useLoginData/* useLoginData */.Q)();
    (0,react.useEffect)(()=>{
        if (!isAuthLoading && !isArticleLoading) {
            setArticleViewed(article === null || article === void 0 ? void 0 : article._id);
        }
    }, [
        isAuthLoading,
        isArticleLoading
    ]);
    useGtmArticlePageView(article);
    const scrollableRef = (0,react.useRef)(null);
    const { idleModal , closeIdleModal  } = useIdleModal(isMobile, scrollableRef);
    let breadcrumbs = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
            href: "/article-classification/".concat(articleData === null || articleData === void 0 ? void 0 : (_articleData_articleClassification = articleData.articleClassification) === null || _articleData_articleClassification === void 0 ? void 0 : _articleData_articleClassification.urlId),
            $origin: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                    children: articleData === null || articleData === void 0 ? void 0 : (_articleData_articleClassification1 = articleData.articleClassification) === null || _articleData_articleClassification1 === void 0 ? void 0 : _articleData_articleClassification1.name
                })
            })
        }, "classification-page"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body2",
            color: "textSecondary",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                children: articleData === null || articleData === void 0 ? void 0 : articleData.title
            }, "article-content")
        })
    ];
    if (isLarge) {
        breadcrumbs = [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                href: "/",
                $origin: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                        children: "首頁"
                    })
                })
            }, "homepage"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                href: "/article",
                $origin: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                        children: "找好文"
                    })
                })
            }, "article-page")
        ].concat(breadcrumbs);
    }
    return isArticleLoading ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        fixContentHeight: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableWrapper/* default */.Z, {
                wrapperRef: scrollableRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleWrapper, {
                        mt: 2,
                        children: [
                            isXLarge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContent_Absolute, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton/* default */.Z, {
                                            shareText: articleData.title,
                                            isColumn: isXLarge,
                                            utmSource: "livinglife_article"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "100%"
                                },
                                children: (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigateNext/* default */.Z, {
                                        fontSize: "small"
                                    }),
                                    "aria-label": "breadcrumb",
                                    children: breadcrumbs
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContentWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: 12,
                                                    display: "flex",
                                                    justifyContent: "start",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h3",
                                                        component: "h1",
                                                        children: articleData === null || articleData === void 0 ? void 0 : articleData.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: 3,
                                                    mb: 10,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                        container: true,
                                                        justifyContent: "start",
                                                        alignItems: "center",
                                                        spacing: 3,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                item: true,
                                                                xs: 12,
                                                                md: "auto",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* OneLineGrid */.$, {
                                                                        container: true,
                                                                        spacing: 4,
                                                                        justifyContent: "center",
                                                                        $height: "60px",
                                                                        children: articleData === null || articleData === void 0 ? void 0 : (_articleData_keywords = articleData.keywords) === null || _articleData_keywords === void 0 ? void 0 : _articleData_keywords.map((keyword)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                                item: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* default */.Z, {
                                                                                    href: "/article/tag/".concat(keyword.urlId),
                                                                                    size: "lg",
                                                                                    children: keyword.name
                                                                                })
                                                                            }, keyword._id))
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                item: true,
                                                                xs: 12,
                                                                md: "auto",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    flexWrap: "nowrap",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconInfos, {
                                                                        article: article
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            md: 8,
                                            pr: {
                                                xs: 0,
                                                md: 15
                                            },
                                            children: [
                                                !!(articleData === null || articleData === void 0 ? void 0 : articleData.image) && !(article === null || article === void 0 ? void 0 : article.isImageInvisible) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainImgBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImg, {
                                                            src: articleData === null || articleData === void 0 ? void 0 : (_articleData_image = articleData.image) === null || _articleData_image === void 0 ? void 0 : _articleData_image.url,
                                                            alt: articleData === null || articleData === void 0 ? void 0 : articleData.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImageMaskWithLogo, {
                                                            venderName: ((_articleData_vender = articleData.vender) === null || _articleData_vender === void 0 ? void 0 : _articleData_vender.shortname) || (articleData === null || articleData === void 0 ? void 0 : articleData.byline),
                                                            venderVatNo: articleById === null || articleById === void 0 ? void 0 : (_articleById_vender = articleById.vender) === null || _articleById_vender === void 0 ? void 0 : _articleById_vender.vatNo,
                                                            theme: theme
                                                        })
                                                    ]
                                                }),
                                                articleData === null || articleData === void 0 ? void 0 : (_articleData_docContents = articleData.docContents) === null || _articleData_docContents === void 0 ? void 0 : _articleData_docContents.map((content, index)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            (content === null || content === void 0 ? void 0 : content.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                mb: 3,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "h4",
                                                                    fontWeight: "fontWeightBold",
                                                                    component: "h2",
                                                                    children: content === null || content === void 0 ? void 0 : content.title
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLContent/* default */.Z, {
                                                                content: content === null || content === void 0 ? void 0 : content.content,
                                                                type: "article"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                mb: 14
                                                            })
                                                        ]
                                                    }, "content-".concat(index));
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    item: true,
                                                    display: "flex",
                                                    justifyContent: "start",
                                                    alignItems: "center",
                                                    xs: 12,
                                                    pt: 6,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallVenderIconImage, {
                                                            alt: "",
                                                            src: (articleVenderLogoImage === null || articleVenderLogoImage === void 0 ? void 0 : articleVenderLogoImage.url) || "/img/img_headshot_default.png",
                                                            onClick: !!(articleData === null || articleData === void 0 ? void 0 : (_articleData_vender1 = articleData.vender) === null || _articleData_vender1 === void 0 ? void 0 : (_articleData_vender_introductionInfo = _articleData_vender1.introductionInfo) === null || _articleData_vender_introductionInfo === void 0 ? void 0 : _articleData_vender_introductionInfo.isVisible) ? ()=>{
                                                                var _articleData_vender;
                                                                router.push("/vender/".concat(articleData === null || articleData === void 0 ? void 0 : (_articleData_vender = articleData.vender) === null || _articleData_vender === void 0 ? void 0 : _articleData_vender.urlId));
                                                            } : null,
                                                            style: {
                                                                cursor: !!(articleData === null || articleData === void 0 ? void 0 : (_articleData_vender2 = articleData.vender) === null || _articleData_vender2 === void 0 ? void 0 : (_articleData_vender_introductionInfo1 = _articleData_vender2.introductionInfo) === null || _articleData_vender_introductionInfo1 === void 0 ? void 0 : _articleData_vender_introductionInfo1.isVisible) ? "pointer" : "default"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            ml: 2,
                                                            variant: "subtitle2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                fontWeight: "fontWeightBold",
                                                                children: !!(articleData === null || articleData === void 0 ? void 0 : (_articleData_vender3 = articleData.vender) === null || _articleData_vender3 === void 0 ? void 0 : (_articleData_vender_introductionInfo2 = _articleData_vender3.introductionInfo) === null || _articleData_vender_introductionInfo2 === void 0 ? void 0 : _articleData_vender_introductionInfo2.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                                                    href: "/vender/".concat((_articleData_vender4 = articleData.vender) === null || _articleData_vender4 === void 0 ? void 0 : _articleData_vender4.urlId),
                                                                    $origin: true,
                                                                    children: (_articleData_vender5 = articleData.vender) === null || _articleData_vender5 === void 0 ? void 0 : _articleData_vender5.shortname
                                                                }) : articleData === null || articleData === void 0 ? void 0 : articleData.byline
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContent_Controls, {
                                                        article: articleData
                                                    })
                                                }),
                                                !isXLarge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton/* default */.Z, {
                                                        shareText: articleData.title,
                                                        utmSource: "livinglife_article"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: 25,
                                                    mb: 15,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            width: {
                                                                xs: "98%",
                                                                md: "90%"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCarouselForArticle/* default */.Z, {
                                                            displayInfo: "articlepage",
                                                            classification: article === null || article === void 0 ? void 0 : (_article_articleClassification = article.articleClassification) === null || _article_articleClassification === void 0 ? void 0 : _article_articleClassification._id,
                                                            isMobile: isMobile,
                                                            bannerLocation: "文章頁面"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContent_LatestArticle, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            md: 4,
                                            children: [
                                                isMedium && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContent_VenderInfo, {
                                                        venderData: articleById === null || articleById === void 0 ? void 0 : articleById.vender,
                                                        articleByLine: articleData === null || articleData === void 0 ? void 0 : articleData.byline
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: {
                                                        xs: 12,
                                                        md: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuessLikesList/* default */.Z, {
                                                        article: articleData
                                                    })
                                                }),
                                                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            mb: 6,
                                                            mt: 12,
                                                            fontWeight: "fontWeightBold",
                                                            children: "文章分類"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            container: true,
                                                            spacing: 2,
                                                            children: showArticleClassifications && showArticleClassifications.map((item, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleClassifications, {
                                                                    articleClassificationItem: item
                                                                }, "item-".concat(index));
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSpacing, {}),
                    (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicFooter, {})
                ]
            }),
            isLarge && (idleModal === null || idleModal === void 0 ? void 0 : idleModal.open) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicIdleModal, {
                open: idleModal === null || idleModal === void 0 ? void 0 : idleModal.open,
                onClose: closeIdleModal,
                articleClassificationId: article === null || article === void 0 ? void 0 : (_article_articleClassification1 = article.articleClassification) === null || _article_articleClassification1 === void 0 ? void 0 : _article_articleClassification1._id,
                articleId: article === null || article === void 0 ? void 0 : article._id
            })
        ]
    });
};
/* harmony default export */ var Article_ArticleContent = (ArticleContent);


/***/ }),

/***/ 33863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ generateShortUrls; }
/* harmony export */ });
const generateShortUrls = (data)=>{
    return fetch("https://link.livinglife.com.tw", {
        method: "POST",
        body: JSON.stringify(data)
    }).then((res)=>res.json()).then((res)=>[
            res || {}
        ]).catch((error)=>{
        console.error(error);
        return [
            undefined,
            error
        ];
    });
};


/***/ }),

/***/ 55108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useAlbums; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useAlbums = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/albums?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
                ...propsObject,
                limit: 30
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 19575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getVenderWelcomeInfo; }
/* harmony export */ });
const getText = (value)=>{
    if (typeof value === "string") return value;
    return (value === null || value === void 0 ? void 0 : value.text) || "";
};
const getVenderWelcomeInfo = (vender)=>{
    var _welcomeInfoSetting_logo;
    const welcomeInfoSetting = (vender === null || vender === void 0 ? void 0 : vender.welcomeInfoSetting) || {};
    const typicalImages = (welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.typicalImages) || {};
    return {
        logoImage: (welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : (_welcomeInfoSetting_logo = welcomeInfoSetting.logo) === null || _welcomeInfoSetting_logo === void 0 ? void 0 : _welcomeInfoSetting_logo.image) || null,
        typicalImage: (typicalImages === null || typicalImages === void 0 ? void 0 : typicalImages.typicalImage) || null,
        typicalMobileImage: (typicalImages === null || typicalImages === void 0 ? void 0 : typicalImages.typicalMobileImage) || null,
        announcementText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.announcement),
        favorableDiscountText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.favorableDiscount),
        brieflyDescribeText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.brieflyDescribe)
    };
};


/***/ })

}]);